import { datadogRum } from '@datadog/browser-rum';
import { config, datadogEnabled } from '../config';

let started = false;

/** Datadog RUM with distributed tracing into the API (same setup as the Flutter client). */
export function initTelemetry(version: string) {
  if (!datadogEnabled || started) return;
  started = true;
  datadogRum.init({
    applicationId: config.datadog.applicationId,
    clientToken: config.datadog.clientToken,
    site: 'datadoghq.com',
    service: config.datadog.service,
    env: config.datadog.env,
    version,
    sessionSampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: config.apiHost
      ? [{ match: (url: string) => new URL(url, location.href).host === config.apiHost, propagatorTypes: ['tracecontext', 'datadog'] }]
      : [],
  });
}

export function setTelemetryUser(uid: string | null) {
  if (!started) return;
  if (uid) datadogRum.setUser({ id: uid });
  else datadogRum.clearUser();
}

export function reportError(error: unknown, context?: Record<string, unknown>) {
  if (!started) return;
  datadogRum.addError(error, context);
}
